<template>
  <section>
    <div class="appointment-type">
      <div class="heading-appoitment emt-6">Add other group form</div>
      <name-vue />
      <div class="heading-appoitment emt-6">Video Group</div>
      <is-video-vue />
      <div class="heading-appoitment emt-6">Group Members</div>
      <select-members-vue />
      <div
        class="members-list-wrapper"
        :class="{ border: selected.length > 0 }"
      >
        <members-list-vue />
      </div>
    </div>
  </section>
</template>

<script>
import NameVue from "./Form/Name.vue";
import IsVideoVue from "./Form/IsVideo.vue";
import SelectMembersVue from "./Form/SelectMembers.vue";
import MembersListVue from "./MembersList.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    NameVue,
    IsVideoVue,
    SelectMembersVue,
    MembersListVue
  },
  computed: {
    ...mapGetters("group", {
      selected: "getSelected"
    })
  }
};
</script>

<style scoped>
.border {
  border-bottom: 1px solid #f2f2f2;
}
</style>
